/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var PLACEMENT;
(function (PLACEMENT) {
    PLACEMENT["LEFT"] = "left";
    PLACEMENT["LEFT_START"] = "left-start";
    PLACEMENT["LEFT_END"] = "left-end";
    PLACEMENT["RIGHT"] = "right";
    PLACEMENT["RIGHT_START"] = "right-start";
    PLACEMENT["RIGHT_END"] = "right-end";
    PLACEMENT["TOP"] = "top";
    PLACEMENT["TOP_START"] = "top-start";
    PLACEMENT["TOP_END"] = "top-end";
    PLACEMENT["BOTTOM"] = "bottom";
    PLACEMENT["BOTTOM_START"] = "bottom-start";
    PLACEMENT["BOTTOM_END"] = "bottom-end";
})(PLACEMENT || (PLACEMENT = {}));

var supportsPassive = false;
if (typeof window !== 'undefined') {
    supportsPassive = false;
    try {
        // @ts-ignore
        window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
            get: function () { supportsPassive = true; },
        }));
    }
    catch (e) { }
}
var isIOS = false;
if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
    // @ts-expect-error MSStream is missing in window type
    isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}
var LocalEventHandler = /** @class */ (function () {
    function LocalEventHandler() {
        this._listeners = [];
    }
    LocalEventHandler.prototype.on = function (targets, type, handler) {
        this._listeners.push({ targets: targets, type: type, handler: handler });
        targets.forEach(function (t) {
            t.addEventListener(type, handler, supportsPassive ? { passive: true } : undefined);
        });
    };
    LocalEventHandler.prototype.clear = function () {
        this._listeners.forEach(function (_a) {
            var targets = _a.targets, type = _a.type, handler = _a.handler;
            targets.forEach(function (t) { return t.removeEventListener(type, handler); });
        });
        this._listeners = [];
    };
    return LocalEventHandler;
}());
var GlobalEventHandler = /** @class */ (function () {
    function GlobalEventHandler() {
        this._listeners = {
            click: [],
            mousedown: [],
            touchend: [],
        };
        this._started = false;
    }
    GlobalEventHandler.prototype.on = function (eventType, handler) {
        if (!this._listeners[eventType].includes(handler)) {
            this._listeners[eventType].push(handler);
        }
    };
    GlobalEventHandler.prototype.off = function (eventType, handler) {
        var index = this._listeners[eventType].indexOf(handler);
        if (index !== -1) {
            this._listeners[eventType].splice(index, 1);
        }
    };
    GlobalEventHandler.prototype.start = function () {
        var _this = this;
        if (this._started) {
            return;
        }
        this._started = true;
        var emit = function (type) { return function (event) { return _this._listeners[type].forEach(function (fn) { return fn(event); }); }; };
        var passive = supportsPassive ? { passive: true, capture: true } : true;
        if (typeof document !== 'undefined' && typeof window !== 'undefined') {
            if (isIOS) {
                document.addEventListener('touchstart', emit('mousedown'), passive);
                document.addEventListener('touchend', emit('touchend'), passive);
            }
            else {
                window.addEventListener('mousedown', emit('mousedown'), true);
                window.addEventListener('click', emit('click'), true);
            }
        }
    };
    return GlobalEventHandler;
}());
var globalEventHandler = new GlobalEventHandler();
if (typeof window !== 'undefined') {
    globalEventHandler.start();
}

var onClick = function (event) {
    var _a;
    var el = event.currentTarget;
    event.omnicaPopperClose = !el.omnicaPopperCloserTouched;
    event.omnicaPopperCloseAll = !!((_a = el.omnicaPopperCloserModifiers) === null || _a === void 0 ? void 0 : _a.all);
};
var onTouchEnd = (function (event) {
    var _a;
    var el = event.currentTarget;
    var first = el.omnicaPopperCloserTouch;
    delete el.omnicaPopperCloserTouch;
    if (event.changedTouches.length === 1) {
        var touch = event.changedTouches[0];
        event.omnicaPopperClose = (Math.abs(touch.screenY - first.screenY) < 20 &&
            Math.abs(touch.screenX - first.screenX) < 20);
        event.omnicaPopperCloseAll = !!((_a = el.omnicaPopperCloserModifiers) === null || _a === void 0 ? void 0 : _a.all);
    }
});
var onTouchCancel = (function (event) {
    var el = event.currentTarget;
    delete el.omnicaPopperCloserTouch;
});
var onTouchStart = (function (event) {
    if (event.changedTouches.length === 1) {
        var el = event.currentTarget;
        el.omnicaPopperCloserTouch = event.changedTouches[0];
        el.addEventListener('touchend', onTouchEnd);
        el.addEventListener('touchcancel', onTouchCancel);
    }
});
var addCloserListeners = function (el) {
    el.addEventListener('click', onClick);
    el.addEventListener('touchstart', onTouchStart, supportsPassive
        ? { passive: true }
        : false);
};
var removeCloserListeners = function (el) {
    el.removeEventListener('click', onClick);
    el.removeEventListener('touchstart', onTouchStart);
    el.removeEventListener('touchend', onTouchEnd);
    el.removeEventListener('touchcancel', onTouchCancel);
};

var normalizeDelay = function (delay) { return (__assign({ show: 0, hide: 0 }, (typeof delay === 'object' ? delay : {
    show: Number(delay),
    hide: Number(delay),
}))); };
var nextAnimationFrame = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, new Promise(function (resolve) { return requestAnimationFrame(resolve); })];
}); }); };
var renameAttribute = function (el, src, dst) {
    if (el.hasAttribute(src)) {
        el.setAttribute(dst, el.getAttribute(src));
        el.removeAttribute(src);
    }
};

export { LocalEventHandler, PLACEMENT, addCloserListeners, globalEventHandler, nextAnimationFrame, normalizeDelay, removeCloserListeners, renameAttribute, supportsPassive };
